import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { v4 as uuidv4 } from 'uuid';

export const getDeviceFingerprint = async () => {
  const fpPromise = FingerprintJS.load();

  const fp = await fpPromise;
  const result = await fp.get();
  let deviceId;
  deviceId = localStorage.getItem('deviceId');
  if (deviceId === 'undefined' || !deviceId || deviceId === 'null') {
    deviceId = result?.visitorId + uuidv4();
    localStorage.setItem('deviceId', deviceId);
  }

  return deviceId;
};
